import React from 'react'
import { Form } from 'react-bootstrap'
import { PatternFormat } from 'react-number-format'

const MobileNumberInput = React.forwardRef((props = {}, ref) => {
  const { onChange, onBlur, name, label, errors = {} } = props
  return (
    <Form.Group className="mb-3" controlId={name}>
      <Form.Label>
        {label}
        <span className="text-danger ml-0.5 text-base">*</span>
      </Form.Label>
      <PatternFormat
        required
        className="form-control shadow-none"
        format="(###) ### ####"
        mask="_"
        placeholder="(987) 456 3210"
        type="text"
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        customInput={(inputProps) => {
          return (
            <Form.Control {...inputProps} ref={ref} isInvalid={errors[name]} />
          )
        }}
      />
      <Form.Control.Feedback type="invalid">
        {errors[name]?.message || ''}
      </Form.Control.Feedback>
    </Form.Group>
  )
})

export default MobileNumberInput
